import { Link } from 'react-router-dom'
import { Phone, MapPin, Linkedin, Facebook, Instagram } from 'lucide-react'
import { tenantConfig } from '../config/tenant'
import Logo from './Logo'

// Greystone business details. Single-tenant for now; move to tenant config (VITE_TENANT_*)
// if a second tenant is onboarded. ACL wording is compliance copy — do not paraphrase.
const PHONE_DISPLAY = '03 9191 0274'
const PHONE_TEL = '0391910274'
const OFFICE_ADDRESS = '811/1 Queens Road, Melbourne VIC 3004, Australia'
const ACL_LINE =
  'Greystone Finance Pty Ltd ACN 668 602 846 is authorised under LMG Broker Services Pty Ltd ACN 632 405 504 Australian Credit Licence 517192'
const SOCIALS = {
  linkedin: 'https://au.linkedin.com/company/greystone-finance',
  facebook: 'https://www.facebook.com/people/Greystone-Finance/100095163582692/',
  instagram: 'https://www.instagram.com/greystone.finance/',
}

const iconBtn =
  'w-9 h-9 rounded-full bg-white/10 grid place-items-center text-white/80 hover:bg-white/20 hover:text-white transition-colors'
const footLink = 'text-white/60 hover:text-white transition-colors'

export default function Footer() {
  const year = new Date().getFullYear()
  return (
    <footer className="mt-24 text-sm" style={{ background: tenantConfig.primaryColor }}>
      <div className="max-w-7xl mx-auto px-6 py-14 grid gap-10 md:grid-cols-4">
        {/* Brand + contact + socials (Chelston mockup) */}
        <div className="md:col-span-2 max-w-md">
          <div className="mb-5">
            <Logo size={28} />
          </div>
          <p className="text-white/60 leading-relaxed mb-3">{ACL_LINE}</p>
          <p className="text-white/60 leading-relaxed mb-6">Proud member of the MFAA (Mortgage &amp; Finance Association of Australia).</p>

          <div className="flex items-start gap-3 text-white/70 mb-4">
            <span className="w-9 h-9 rounded-full bg-white/10 grid place-items-center shrink-0">
              <MapPin size={16} />
            </span>
            <span className="pt-2">{OFFICE_ADDRESS}</span>
          </div>

          <a
            href={`tel:${PHONE_TEL}`}
            className="inline-flex items-center gap-3 text-white hover:opacity-90"
          >
            <span className="w-9 h-9 rounded-full bg-white/10 grid place-items-center">
              <Phone size={16} />
            </span>
            {PHONE_DISPLAY}
          </a>

          <div className="mt-8 pt-6 border-t border-white/10">
            <div className="text-white/80 font-medium mb-3">Follow Us:</div>
            <div className="flex items-center gap-3">
              <a href={SOCIALS.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className={iconBtn}>
                <Linkedin size={16} />
              </a>
              <a href={SOCIALS.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className={iconBtn}>
                <Facebook size={16} />
              </a>
              <a href={SOCIALS.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className={iconBtn}>
                <Instagram size={16} />
              </a>
            </div>
          </div>
        </div>

        {/* Explore */}
        <div>
          <div className="font-heading font-semibold text-white text-sm mb-3">Explore</div>
          <ul className="space-y-2">
            <li><Link to="/" className={footLink}>Home</Link></li>
            <li><Link to="/about" className={footLink}>About Us</Link></li>
            <li><Link to="/services" className={footLink}>Services</Link></li>
            <li><Link to="/tools" className={footLink}>Tools & calculators</Link></li>
            <li><Link to="/playbook" className={footLink}>Playbook</Link></li>
            <li><Link to="/debt-recycling" className={footLink}>Debt recycling</Link></li>
            <li><Link to="/blog" className={footLink}>Blog</Link></li>
            <li><Link to="/contact" className={footLink}>Contact</Link></li>
          </ul>
        </div>

        {/* Regulatory + Broker access */}
        <div>
          <div className="font-heading font-semibold text-white text-sm mb-3">Regulatory</div>
          <ul className="space-y-2">
            <li><Link to="/hardship" className={footLink}>Hardship Hub</Link></li>
            <li><Link to="/complaints" className={footLink}>Complaints</Link></li>
            <li><Link to="/privacy" className={footLink}>Privacy policy</Link></li>
          </ul>
          <div className="font-heading font-semibold text-white text-sm mb-3 mt-6">Broker access</div>
          <ul className="space-y-2">
            <li><Link to="/dataentry/login" className={footLink}>Broker login</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-4 text-xs text-white/40 flex justify-between">
          <div>&copy; {year} {tenantConfig.name}. All rights reserved.</div>
          <div>Powered by LoanLoop SaaS, LoanLoop Pty Ltd</div>
        </div>
      </div>
    </footer>
  )
}
